import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import Footer from "../../pages/Authentication/Footer"
import { Link } from "react-router-dom"

const RegisterSection = props => {
  const [error, setError] = useState(props.error)
  const [loading, setloading] = useState(false)

  useEffect(() => {
    setError(props.error)
    setloading(false)
  }, [props.error])
  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={4}>
            <Card className="overflow-hidden">
              <div className="bg-primary">
                <div className="text-primary text-center p-4">
                  <h5 className="text-white font-size-20">Register</h5>
                  <p className="text-white-50">
                    Create an Account to start using our services.
                  </p>
                  <a href="#" className="logo logo-admin">
                    <img src={logoSm} height="24" alt="logo" />
                  </a>
                </div>
              </div>
              <CardBody className="p-4">
                <div className="p-3">
                  <AvForm
                    className="mt-4"
                    onValidSubmit={(e, v) => {
                      setloading(true)
                      props.handleValidSubmit(e, v)
                    }}
                  >
                    {error ? (
                      <Alert color="danger">{props.errorMsg}</Alert>
                    ) : null}
                    <div className="mb-3">
                      <AvField
                        name="firstName"
                        label="First Name"
                        type="text"
                        required
                        placeholder="Enter first Name"
                      />
                    </div>
                    <div className="mb-3">
                      <AvField
                        name="lastName"
                        label="Last Name"
                        type="text"
                        required
                        placeholder="Enter Last Name"
                      />
                    </div>
                    <div className="mb-3">
                      <AvField
                        name="otherNames"
                        label="Other Names"
                        type="text"
                        placeholder="Enter other Names"
                      />
                    </div>

                    <div className="mb-3">
                      <AvField
                        name="phone"
                        label="Phone"
                        type="phone"
                        validate={{
                          required: { value: true },
                          maxLength: {
                            value: 10,
                            errorMessage: "Enter a 10 digit phone number.",
                          },
                          minLength: {
                            value: 10,
                            errorMessage: "Enter a 10 digit phone number.",
                          },
                        }}
                        placeholder="Enter Phone Number"
                      />
                    </div>

                    <div className="mb-3">
                      <AvField
                        id="email"
                        name="email"
                        label="Email"
                        className="form-control"
                        placeholder="Enter email"
                        type="email"
                        required
                      />
                    </div>

                    <div className="mb-3 row">
                      <div className="col-12 text-end">
                        {loading ? (
                          <Link to="#" className="spinner-border text-info" />
                        ) : (
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Register
                          </button>
                        )}
                      </div>
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
            <div className="mt-5 text-center">
              <p>
                Already have an account ?{" "}
                <Link to="/login" className="fw-medium text-primary">
                  {" "}
                  Login
                </Link>{" "}
              </p>
              <Footer />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default RegisterSection
